import { addPathPrefix } from '@/utils/path';

export function getFlowJobPageURL({
  projectId = window.w.projectId,
  flowId,
  jobId = '',
  envId = window.w.env,
  branchId, // = envId === 'dev' && window.RUNTIME_CONFIGS.branch,  // 暂时不考虑填入默认值，避免奇怪问题
  hashData = '',
}) {
  const url = new URL(location.href);
  let envPart = envId;
  if (branchId && envPart === 'dev') envPart = `branch/${branchId}`;
  url.pathname = addPathPrefix(`/xy/app/${envPart}/${encodeURIComponent(projectId)}/wuji/workflow/flow/${encodeURIComponent(flowId)}`);
  url.search = '';
  url.searchParams.set('projectId', projectId);
  if (jobId) url.searchParams.set('jobId', jobId);
  if (hashData)url.hash = hashData;
  return url.toString();
}
